<script>
  import Field from "./Field.svelte";
  let winCombos = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6],
  ];

  let arr = [];
  let usersTurn = true;
  let message = "";
  let difficulty = "Easy"; // Default difficulty level
  let gameStarted = false; // Track if a game is in progress
 // Declare message variable outside of functions

 const winner = (perc) => {
  if (arr.length >= 5) {
    let arr2 = arr.filter((val, i) => i % 2 == perc);

    winCombos.forEach((array) => {
      if (array.every((element) => arr2.includes(element))) {
        if (perc == 0) {
          message = difficulty === "Friend" ? "Player 1 (X) Won!" : "You Won!";
          highlightWinningCombination(array, "#58D68D");
          showCongratsMessage("Congratulations! You Won!");
        } else {
          message = difficulty === "Friend" ? "Player 2 (O) Won!" : "PC Won!";
          highlightWinningCombination(array, "#EC7063");
          showCongratsMessage("PC Won!");
        }
        gameStarted = false; // Game ends
        const gameFrame = document.querySelector(".game-frame");
        gameFrame.classList.add("win-animation"); // Add win animation class
      }
    });

    if (arr.length === 9 && !message) {
      message = "Game Tie!";
      showCongratsMessage("It's a Tie!");
      gameStarted = false; // Game ends
      const gameFrame = document.querySelector(".game-frame");
      gameFrame.classList.add("tie-animation"); // Add tie animation class
    }
  }
};



const showCongratsMessage = (msg) => {
  const congratsMsg = document.querySelector(".congrats-message");
  congratsMsg.textContent = msg;
  congratsMsg.style.opacity = 1;
  congratsMsg.style.transform = "translateY(0)";
};
// const highlightWinningCombination = (combination, color) => {
//   const gameFrame = document.querySelector(".game-frame");
//   combination.forEach((index) => {
//     const cell = gameFrame.childNodes[index];
//     cell.classList.add("strike-through");
//   });
// };


  const userMove = (e) => {
  if (e.target.innerHTML === "" && !message) {
    gameStarted = true;
    if (difficulty === "Friend") {
      // Alternate turns between Player 1 (X) and Player 2 (O)
      if (usersTurn) {
        e.target.innerHTML = "X";
        // Handle Player 1's move logic
      } else {
        e.target.innerHTML = "O";
        // Handle Player 2's move logic
      }
      arr.push(parseInt(e.target.getAttribute("number")));
      winner(usersTurn ? 0 : 1); // Check if a player has won
      usersTurn = !usersTurn;
      gameStarted = true; // Switch turns between players
    } else {
      // Logic for single-player mode against AI (current implementation)
      e.target.innerHTML = "X";
      arr.push(parseInt(e.target.getAttribute("number")));
      winner(0); // Check if the user has won
      usersTurn = false; // Switch turns to AI
      gameStarted = true; // Game is in progress
      if (arr.length < 9 && !message) {
        setTimeout(pcMove, 500); // Call pcMove after a delay
      } else if (arr.length === 9 && !message) {
        message = "Game Tie!";
        gameStarted = false; // End game on tie
      }
    }
  }
};

const pcMove = () => {
  if (!message) {
    if (difficulty === "Easy") {
      pcMoveEasy();
    } else if (difficulty === "Medium") {
      pcMoveMedium();

    } else if (difficulty === "Hard") {
      pcMoveHard();
      gameStarted = true;   //to
    } else if (difficulty === "Friend") {
      // Handle player vs player logic
      if (usersTurn) {
        // Player 1's turn (X)
        // Implement logic for Player 1's move
      } else {
        // Player 2's turn (O)
        // Implement logic for Player 2's move
      }
    }
  }
};



const pcMoveEasy = () => {
  let num;
  do {
    num = Math.floor(Math.random() * 9);
  } while (arr.includes(num));

  const game = document.querySelector(".game-frame");
  game.childNodes[num].innerHTML = "O";

  arr.push(num);
  usersTurn = true;
  winner(1); // Check if the AI has won
};

  const pcMoveMedium = () => {
    let num;
    let arr2 = arr.filter((val, i) => i % 2 == 0);
    let arr3 = arr.filter((val, i) => i % 2 == 1);

    for (let array of winCombos) {
      if (
        array.some((element) => arr2.includes(element)) &&
        !array.some((element) => arr3.includes(element))
      ) {
        const findCommon = (a, b) => a.filter((n) => b.indexOf(n) !== -1);
        const common = findCommon(array, arr2);

        const findMissing = (a, b) => a.filter((n) => b.indexOf(n) == -1);
        const missing = findMissing(array, common);

        if (common.length == 2 && !arr.includes(missing[0])) {
          num = missing[0];
          break;
        }
      }
    }

    if (num === undefined) {
      do {
        num = Math.floor(Math.random() * 9);
      } while (arr.includes(num));
    }

    const game = document.querySelector(".game-frame");
    game.childNodes[num].innerHTML = "O";

    arr.push(num);
    usersTurn = true;
    winner(1);
  };

  const pcMoveHard = () => {
    let bestScore = -Infinity;
    let move;
    for (let i = 0; i < 9; i++) {
      if (!arr.includes(i)) {
        arr.push(i);
        let score = minimax(arr, 0, false);
        arr.pop();
        if (score > bestScore) {
          bestScore = score;
          move = i;
        }
      }
    }

    const game = document.querySelector(".game-frame");
    game.childNodes[move].innerHTML = "O";

    arr.push(move);
    usersTurn = true;
    winner(1);
  };

  const minimax = (newBoard, depth, isMaximizing) => {
    let result = checkWinner(newBoard);
    if (result !== null) {
      if (result === "O") return 10 - depth;
      else if (result === "X") return depth - 10;
      else return 0;
    }

    if (isMaximizing) {
      let bestScore = -Infinity;
      for (let i = 0; i < 9; i++) {
        if (!newBoard.includes(i)) {
          newBoard.push(i);
          let score = minimax(newBoard, depth + 1, false);
          newBoard.pop();
          bestScore = Math.max(score, bestScore);
        }
      }
      return bestScore;
    } else {
      let bestScore = Infinity;
      for (let i = 0; i < 9; i++) {
        if (!newBoard.includes(i)) {
          newBoard.push(i);
          let score = minimax(newBoard, depth + 1, true);
          newBoard.pop();
          bestScore = Math.min(score, bestScore);
        }
      }
      return bestScore;
    }
  };

  const checkWinner = (board) => {
    let arr2 = board.filter((val, i) => i % 2 == 0);
    let arr3 = board.filter((val, i) => i % 2 == 1);

    for (let combo of winCombos) {
      if (combo.every((element) => arr2.includes(element))) {
        return "X";
      } else if (combo.every((element) => arr3.includes(element))) {
        return "O";
      }
    }
    return board.length === 9 ? "tie" : null;
  };
  const reset = () => {
  message = ""; // Clear message when resetting
  arr = [];
  usersTurn = true;
  gameStarted = false; // Reset game started state

  const gameFrame = document.querySelector(".game-frame");
  gameFrame.classList.remove("win-animation", "tie-animation"); // Remove animation classes

  const congratsMsg = document.querySelector(".congrats-message");
  congratsMsg.style.opacity = 0;
  congratsMsg.style.transform = "translateY(-50px)";

  const game = document.querySelector(".game-frame").childNodes;
  game.forEach((el) => {
    el.style.backgroundColor = "";
    el.innerHTML = "";
  });
};
</script>
<style>
  main {
    text-align: center;
    padding: 1em;
    max-width: 100%;
    margin: 0 auto;
  }

  .game-frame {
  max-width: 500px;
  min-height: 500px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 10px;
}

  .field {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-size: 6rem;
    color:white;
    background-color: #444;
    cursor: pointer;
    user-select: none;
  }

  .button {
    color: rgb(118, 244, 14);
    background: linear-gradient(to right, #333, #555);
    padding: 10px 20px;
    border-radius: 5px;
    margin-top: 20px;
    font-size: 20px;
    cursor: pointer;
    border: none;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: transform 0.2s, box-shadow 0.2s;
    position: relative;
    overflow: hidden;
    z-index: 1; /* Ensure button text is above pseudo-element */
}

.button:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 300%;
    height: 300%;
    background: radial-gradient(circle closest-side, rgba(255, 255, 255, 0.3), transparent);
    transition: width 0.3s ease-out, height 0.3s ease-out, top 0.3s ease-out, left 0.3s ease-out;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    z-index: 0;
}

.button:hover:before {
    width: 0;
    height: 0;
    top: 50%;
    left: 50%;
}


.button:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
}

.button:active {
    transform: scale(0.95);
    box-shadow: none;
}


.title {
  margin-top: auto;
  margin-bottom: 1px;
  font-size: 46px;
  transition: transform 0.3s, opacity 0.3s;
  background: linear-gradient(to right, #ff5733, #ffbd33, #ff5733); /* Gradient colors */
  -webkit-background-clip: text; /* Clip text to the background */
  -webkit-text-fill-color: transparent; /* Hide actual text color */
}

/* .title.animate {
  animation-name: pulse;
  animation-duration: 1s;
  animation-iteration-count: infinite;
} */

@keyframes pulse {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}


  .difficulty-selector {
    color: rgba(208, 174, 39, 0.974);
    margin-bottom: 12px;
    align-content: auto; /* Not needed, can be removed */
    font-size: 18px; /* Example size, adjust as needed */
    text-align: center; /* Example alignment, adjust as needed */
    padding: 10px; /* Example padding, adjust as needed */
    /* Example background color, adjust as needed */
    /*border-radius: 1px; /* Example border radius, adjust as needed */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Example box shadow, adjust as needed */
    transition: transform 0.2s, box-shadow 0.2s; /* Example transition, adjust as needed */
}

.difficulty-selector:hover {
    transform: translateY(-2px); /* Example hover effect, adjust as needed */
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.3); /* Example hover box shadow, adjust as needed */
}

</style>

<main>
  <h1 class="title {!message ? '' : 'animate'}">{!message ? "Tic Tac Toe" : message}</h1>
  <div class="difficulty-selector">
    <label for="difficulty">Difficulty: </label>
    <select
      id="difficulty"
      class="button"
      bind:value={difficulty}
      disabled={gameStarted}
    >
      <option value="Easy">Easy</option>
      <option value="Medium">Medium</option>
      <option value="Hard">Hard</option>
      <option value="Friend">Play with Friend</option>
    </select>
  </div>
  <div class="game-frame {!message && !gameStarted ? '' : (message ? 'win-animation' : 'tie-animation')}">
    {#each Array(9) as _, index}
      <div class="field {arr.includes(index) ? 'strike-through' : ''}" on:click={userMove} number={index}></div>
    {/each}
  </div>
  

  <!-- Congrats message -->
  {#if message}
    <div class="congrats-message">{message}</div>
  {/if}

  <!-- Play Again button -->
  <button class="button" on:click={reset}>
    {!message ? "Reset" : "Play Again"}
  </button>
</main>
